import {VFC} from 'react';
import {IPayloadClientHistory, TModeHistory} from './BookingClientHistory';
import {useFetchOrderClientQuery} from '../../features/api/booking-order-api';
import {Spinner} from 'ui-kit';
import styles from './styles.module.scss';
import {BookingHistoryItem} from './BookingHistoryItem';
import {Pagination} from 'components/Pagination';

interface Props {
  clientId: number,
  payload: IPayloadClientHistory,
  paginationHandler: (page:number) => void,
  mode: TModeHistory,
}

export const OrderClientHistoryList: VFC<Props> = ({clientId, payload, paginationHandler, mode}) => {
  const {data} = useFetchOrderClientQuery({clientId, payload});

  if (!data) return <Spinner />;


  return (
    <>
      <section className={styles.list}>
        {data.content.map((el: any) => (<BookingHistoryItem mode={mode} booking={el} key={el.bookingId} />))}
      </section>
      {!data.empty && (
        <Pagination
          currentPage={data.pageable.pageNumber}
          pageSize={data.pageable.pageSize}
          total={data.totalElements}
          onChange={paginationHandler}
          className={styles.pagination}
        />
      )}
    </>
  );
};
